/// <reference path="../../app.definition.ts" />

import _ from "lodash";
import { CachedItem } from "./_cachedItem";
import { Discussion } from "./discussion";

export class CachedDocument extends CachedItem {
    id: string;
    title: string;
    filename: string;
    filetype: string;
    comments: Array<any>;
    commentsCount: number;
    createdDate: any;
    activityDate: any;
    subjectId: number;
    ownerId: number;
    displayData: string;
    documentType: string;
    type: string;
    documentUsers: Array<any>;
    documentViewerIds: Array<number>;
    uploading: boolean;
    failed: boolean;
    permissionType: string;
    providerType: string;
    keywords: string;
    comment: string;
    lastUpdatedTime: string;
    lastActionTime: string;
    signStatus: number;
    signatureAssigned: boolean;
    rawDocSize: number;
    documentFolderId: number;
    postType: string;
    permissionEndDate: string;
    viewed: boolean;
    assignedFormId: number;
    allUserIds: Array<number>;
    url: string;
    linkType: string;
    parentFolderName: string;
    careItemId: number;
    summaryGenerated: boolean;

    deserialize(input: Discussion): CachedDocument {
        if (!input) {
            return null;
        }

        !!input.id && (this.id = input.id);
        !!input.userId && (this.ownerId = input.userId);
        !!input.ownerId && (this.ownerId = input.ownerId);
        !!input.title && (this.title = input.title);
        !!input.filename && (this.filename = input.filename);
        !!input.filetype && (this.filetype = input.filetype);
        // !!input.createdDate && !!input.createdDate.getTime && (this.createdDate = input.createdDate.getTime());
        // !!input.activityDate && !!input.activityDate.getTime && (this.activityDate = input.activityDate.getTime());
        !!input.subjectId && (this.subjectId = input.subjectId);
        !!input.displayData && (this.displayData = input.displayData);
        !!input.documentType && (this.documentType = input.documentType);
        !!input.permissionType && (this.permissionType = input.permissionType);
        !!input.providerType && (this.providerType = input.providerType);
        !!input.type && (this.type = input.type);
        !!input.comments && (this.comments = input.comments);
        input.comment && (this.comment = input.comment);
        input.keywords && (this.keywords = input.keywords);
        input.lastUpdatedTime && (this.lastUpdatedTime = input.lastUpdatedTime);
        input.lastActionTime && (this.lastActionTime = input.lastActionTime);
        (input.uploading != null) && (this.uploading = input.uploading);
        (input.failed != null) && (this.failed = input.failed);
        !!input.signStatus && (this.signStatus = input.signStatus);
        !!input.rawDocSize && (this.rawDocSize = input.rawDocSize);
        !!input.documentFolderId && (this.documentFolderId = input.documentFolderId);
        input.postType && (this.postType = input.postType);
        input.url && (this.url = input.url);
        input.linkType && (this.linkType = input.linkType);
        input.parentFolderName && (this.parentFolderName = input.parentFolderName);
        this.signatureAssigned = input.signatureAssigned;
        this.signStatus = input.signStatus;
        this.permissionEndDate = input.permissionEndDate;
        this.viewed = input.viewed;
        !!input.assignedFormId && (this.assignedFormId = input.assignedFormId);
        input.careItemId && (this.careItemId = input.careItemId);
        this.summaryGenerated = input.summaryGenerated;
        if (!!input.commentsCount) {
            this.commentsCount = input.commentsCount
        } else {
            if (!!input.comments && input.comments.length > 0) {
                this.commentsCount = input.comments.filter(comment => !comment.commentType || comment.commentType == 'USER_DEFINED').length;
            }
        }

        if (!!input.createdDate) {
            if (!!input.createdDate.getTime) {
                this.createdDate = input.createdDate.getTime()
            } else {
                this.createdDate = input.createdDate;
            }
        }
        if (!!input.activityDate) {
            if (!!input.activityDate.getTime) {
                this.activityDate = input.activityDate.getTime()
            } else {
                this.activityDate = input.activityDate;
            }
        }

        this.allUserIds = [];
        this.allUserIds.push(this.ownerId);
        if (!!input.documentUsers && input.documentUsers.length > 0) {
            this.documentUsers = new Array();
            for (let docUser of input.documentUsers) {
                let permission = {
                    'id': docUser.id,
                    'permissionType': docUser.permissionType,
                    'isFormerTeamMember': docUser.isFormerTeamMember,
                    'isActive': docUser.isActive,
                    'permissionEndDate': docUser.permissionEndDate,
                    'isDocDeleted': docUser.isDocDeleted
                }
                this.documentUsers.push(permission);
                this.allUserIds.push(docUser.id);
            };
        }

        if (!!input.documentViewers && input.documentViewers.length > 0) {
            this.documentViewerIds = new Array();
            for (let docViewer of input.documentViewers) {
                this.documentViewerIds.push(docViewer.userId);
                this.allUserIds.push(docViewer.userId);
            };
        } else if (!!input.documentViewerIds && input.documentViewerIds.length > 0) {
            this.documentViewerIds = input.documentViewerIds;
            this.allUserIds = [...this.allUserIds, ...input.documentViewerIds];
        }

        if (!!this.comments && this.comments.length > 0) {
            this.allUserIds.push(this.comments[0].senderId);
        }

        this.allUserIds = _.uniq(this.allUserIds);

        super.deserialize(input);
        return this;
    }

    constructor() {
        super();
    }

    public static from(item: any) {
        return new CachedDocument().deserialize(item);
    }

}
